import templateStr from 'text!./cp-confirmation.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-confirmation-directive/CPConfirmationDirective.js
// module id = 995
// module chunks = 0